import React from "react";
import ReusableDropdown from "../../../components/ReusableDropdown";
import { useSidebar } from "../../SidebarContext";
import {
  Calendar,
  FileText,
  Users,
  Clock,
  Download,
  Share2,
  CheckCircle,
  RefreshCw,
  AlertCircle,
} from "lucide-react";
const ReportCard = ({
  report,
  language,
  theme,
  screenSize,
  styles,
  downloadFormat,
  setDownloadFormat,
  handleDownloadReport,
  onShare,
  translateText,
  text,
}) => {
  let sidebarIsCollapsed = null;
  try {
    const sidebarContext = useSidebar();
    sidebarIsCollapsed = sidebarContext?.isCollapsed ?? null;
  } catch (error) {
    sidebarIsCollapsed = null;
  }

  const dropdownWrapperStyle = {
    position: "relative",
    ...(sidebarIsCollapsed === false ? { width: "200px" } : { width: "250px" }),
  };

  return (
    <div style={styles.reportCard}>
      <div style={styles.reportHeader}>
        <div style={styles.reportTitleSection}>
          <h3 style={styles.reportTitle}>
            {translateText(report.title, "title")}
          </h3>
          {/* <p style={styles.reportDescription}>
            {translateText(report.description, "description")}
          </p> */}
          <div style={styles.reportTags}>
            {report.tags?.slice(0, 3).map((tag, idx) => (
              <span key={idx} style={styles.tag}>
                {translateText(tag, "tag")}
              </span>
            ))}
          </div>
        </div>

       

        
      </div>

      <div style={styles.reportMeta}>
        <div style={styles.metaItem}>
          <Calendar size={screenSize === "xs" ? 12 : 14} />
          <span>
            {new Date(report.lastGenerated).toLocaleDateString(
              language === "ar" ? "ar-EG" : "en-US",
            )}
          </span>
        </div>
        <div style={styles.metaItem}>
          <FileText size={screenSize === "xs" ? 12 : 14} />
          <span>
            {report.size} • {report.format}
          </span>
        </div>
        <div style={styles.metaItem}>
          <Users size={screenSize === "xs" ? 12 : 14} />
          <span>{translateText(report.author, "author")}</span>
        </div>
        <div style={styles.metaItem}>
          <Clock size={screenSize === "xs" ? 12 : 14} />
          <span>{report.estimatedReadTime}</span>
        </div>
      </div>

      <div style={styles.actionButtons}>
        <div style={{ display: "flex", gap: "6px", alignItems: "center", width: "max-content" }}>
          <div
            style={dropdownWrapperStyle}
            onClick={(e) => e.stopPropagation()}
          >
            <ReusableDropdown
              items={[
                { key: "pdf", label: "PDF" },
                { key: "xlsx", label: "Excel" },
              ]}
              value={downloadFormat[report.id] === "xlsx" ? "Excel" : "PDF"}
              onChange={(val) => {}}
              onSelect={(item) => {
                setDownloadFormat((prev) => ({
                  ...prev,
                  [report.id]: item.key,
                }));
              }}
              showClear={false}
              getItemKey={(it) => it.key}
              getItemLabel={(it) => it.label}
              theme={theme}
              language={language}
              maxItems={10}
              showAllOnArrowClick={true}
              inputStyle={{
                padding:
                  "clamp(8px, 1.5vw, 10px) 40px clamp(8px, 1.5vw, 10px) clamp(8px, 1.5vw, 10px)",
                paddingRight:
                  language === "ar" ? "clamp(8px, 1.5vw, 10px)" : "40px",
                paddingLeft:
                  language === "ar" ? "40px" : "clamp(8px, 1.5vw, 10px)",
                borderRadius: "clamp(6px, 1vw, 10px)",
                border:
                  theme === "dark"
                    ? "1px solid rgba(255,255,255,0.2)"
                    : "1px solid rgba(0,0,0,0.1)",
                fontSize: "clamp(11px, 1.5vw, 13px)",
                fontWeight: "600",
                flexShrink: 0,
                cursor: "pointer",
                outline: "none",
              }}
            />
          </div>

          <button
            style={styles.actionBtn("view")}
            onClick={(e) => {
              e.stopPropagation();
              handleDownloadReport(report, downloadFormat[report.id] || "pdf");
            }}
          >
            <Download size={screenSize === "xs" ? 12 : 14} />
            {text[language].download}
          </button>
        </div>
        {/* <button
          style={styles.actionBtn("share")}
          onClick={() => {
            onShare();
          }}
        >
          <Share2 size={screenSize === "xs" ? 12 : 14} />
          {text[language].share}
        </button> */}
      </div>
    </div>
  );
};

export default ReportCard;
